import { TRANSLATIONS_NAMESPACE } from '@wix/app-installer/internal-use';
export const getEnrichedTFunc = i18n => {
  const t = (i18n == null ? void 0 : i18n.t.bind(i18n)) || (() => '');
  return function (key, options) {
    if (options === void 0) {
      options = undefined;
    }
    const isOptionsAnObject = typeof options === 'object';
    return t(key, {
      ...(isOptionsAnObject ? options : {}),
      ns: TRANSLATIONS_NAMESPACE,
      interpolation: {
        ...(isOptionsAnObject ? options.interpolation : {}),
        prefix: '{',
        suffix: '}'
      }
    });
  };
};
//# sourceMappingURL=getEnrichedTFunc.js.map